import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography, Button, Box } from '@mui/material'
import Loading from 'components/generic/Loading'
import { useGetOrgImageQuery } from 'services/assets'

const RequiredDocumentPreview = ({ document, image }) => {
  const { data: orgImage, isLoading: isLoadingOrgImage } = useGetOrgImageQuery(
    {
      filename: image?.filename,
      isTemp: false,
    },
    { skip: !image?.filename },
  )
  const [src, setSrc] = useState(null)

  useEffect(() => {
    if (!image?.filename) {
      setSrc(null)
    } else if (orgImage) {
      setSrc(orgImage)
    }
  }, [orgImage, image])

  return (
    <Stack alignItems="center">
      <Typography variant="body1" color="textPrimary" pt={3} pb={0.5}>
        {document?.name}
      </Typography>
      <Box
        mb={1}
        height={90}
        width={135}
        backgroundColor="rgba(0, 0, 0, 0.2)"
        borderRadius={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {isLoadingOrgImage || !src ? (
          isLoadingOrgImage && <Loading localized localizedSx={{ height: '100%' }} />
        ) : (
          <img
            src={src}
            alt={document?.name}
            style={{
              height: 80,
              width: 125,
              objectFit: 'contain',
            }}
          />
        )}
      </Box>
      <Button startIcon={document?.action?.icon} onClick={() => document?.action?.event()}>
        {document?.action?.label}
      </Button>
    </Stack>
  )
}

RequiredDocumentPreview.propTypes = {
  document: PropTypes.object.isRequired,
  image: PropTypes.object,
}

RequiredDocumentPreview.defaultProps = {
  image: {},
}

export default RequiredDocumentPreview
